<template>
  <div class="bg-[#F3F5F8] rounded flex justify-center items-center">
    <slot />
  </div>
</template>
